import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined
} from "@ant-design/icons";
import {
  Button,
  Col, Form, Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import search from "../../helpers/search";
import useStore from "../../hooks/useStores";
import useSubBrand from "../../hooks/useSubBrands";
import { storeService } from "../../services/StoreService";
import StoresForm from "../StoresPage/StoresForm";
import { store_default } from "./types";

const { Header, Content } = Layout;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
];
const StorePage: React.FC = function () {
  const [brands, loadingbrands] = useSubBrand(1);
  const [countries, setCountries] = useState([] as any);
  const [retailers, setRetailers] = useState([] as any);
  const [regions, setRegions] = useState([] as any);
  const [channels, setChannels] = useState([] as any);
  const [outletClasses, setOutletClasses] = useState([] as any);
  const [manufacturers, setManufacturers] = useState([] as any);
  const [subRegions1, setSubRegions1] = useState([] as any);
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [storesToDisplay, setStoresToDisplay] = useState([]);
  const [state, setState] = useState({
    selected: Object.assign({}, store_default),
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [
    stores,
  ] = useStore(state.pagination.current);
  const onSearch = async (key: string) => {
    const { searchWord } = await form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
        collection: "stores",
      },
    ];
    const searchedData = await search(searchData, storeService, key);
    setStoresToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };

  function onKeyUp(event: { charCode: number }) {
    if (event.charCode === 13) onSearch("name");
  }

  const onClose = async () => {
    const { searchWord } = await form.getFieldsValue();
    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "name",
          value: encodeURIComponent(searchWord),
          collection: "stores",
        },
      ];

      const searchedData = await search(searchData, storeService, "name");
      setStoresToDisplay(searchedData.data);
    } else {
      const searchedData = await storeService.getAll(state.pagination.current);
      const data_storesToDisplay = searchedData.data.stores.length
        ? searchedData.data.stores
        : stores;
      setStoresToDisplay(data_storesToDisplay);
    }

    setSearching(false);
  };


  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await storeService.getAll(pagination.current);
    setStoresToDisplay(data.data.stores);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = await form.getFieldsValue();
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "name",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
        collection: "stores",
      },
    ];

    const data = await search(searchData, storeService, "name");
    setStoresToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setStoresToDisplay(stores.stores);
    if (stores) {
    }
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: stores.total,
      },
    });
  }, [stores]);

  const loading = searching || loadingbrands;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Stores (
              <span style={{ color: "#0a1e96" }}>
                {stores && stores.total ? stores.total : 0}
              </span>
              )
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setIsCreate(true);
                setState({ ...state, selected: store_default });
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col>
                  <Form.Item
                    name="searchWord"
                    shouldUpdate={(prev, cur) => {
                      if (cur.searchWord === "") {
                        onClose();
                      }
                      return true;
                    }}
                  >
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      onKeyPress={onKeyUp}
                      placeholder={"Search"}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setStoresToDisplay(stores.stores);
                              setState({
                                ...state,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: stores.total,
                                },
                              });
                              setIsCreate(false);
                              form.setFieldsValue({
                                searchWord: ""
                              });
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      htmlType="submit"
                      onClick={() => onSearch("name")}
                      style={{ width: 150 }}
                    >
                      Search By Name
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>
        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {!form.getFieldValue("searchWord") ? (
              <Table
                pagination={state.pagination}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        selected: record,
                      });
                      setIsCreate(false)
                      setVisible(true);
                    },
                  };
                }}
                dataSource={storesToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                //pagination={{ position: ["bottomRight"] }}
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        selected: record,
                      });
                      setIsCreate(false);
                      setVisible(true);
                    },
                  };
                }}
                dataSource={storesToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <StoresForm
        visible={visible}
        countries={countries}
        retailers={retailers}
        regions={regions}
        channels={channels}
        outlet_classes={outletClasses}
        manufacturers={manufacturers}
        sub_regions_1={subRegions1}
        values={{
          ...state.selected,
        }}
        isChanged={false}
        setVisible={setVisible}
        isCreate={isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default StorePage;
